import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter';

const OnionCharacter = (props) => {
    const primaryColor = "#f5f5f5"; // Light purple-white
    const secondaryColor = "#e0e0e0"; // Slightly darker shade

    const renderOnionBody = () => (
        <>
            {/* Onion Body - bulbous shape */}
            <mesh castShadow>
                <sphereGeometry args={[0.3, 16, 16]} />
                <meshStandardMaterial color={primaryColor} />
            </mesh>

            {/* Onion layers - rings around the sphere */}
            {[...Array(4)].map((_, i) => {
                const y = -0.1 + i * 0.1; // Position rings from bottom to 3/4 up
                return (
                    <mesh key={i} position={[0, y, 0]} castShadow>
                        <torusGeometry args={[0.3, 0.01, 8, 32]} />
                        <meshStandardMaterial color="#d1c4e9" />
                    </mesh>
                );
            })}

            {/* Onion top/stem */}
            <mesh castShadow position={[0, 0.3, 0]}>
                <cylinderGeometry args={[0.01, 0.1, 0.2, 8]} />
                <meshStandardMaterial color="#c5e1a5" />
            </mesh>

            {/* Root wisps at bottom */}
            {[...Array(6)].map((_, i) => {
                const angle = (i / 6) * Math.PI * 2;
                const x = Math.sin(angle) * 0.1;
                const z = Math.cos(angle) * 0.1;
                return (
                    <mesh key={i} position={[x, -0.28, z]} rotation={[0.3, angle, 0]} castShadow>
                        <cylinderGeometry args={[0.01, 0.01, 0.1, 4]} />
                        <meshStandardMaterial color="#e0e0e0" />
                    </mesh>
                );
            })}
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderOnionBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default OnionCharacter;
